import { AnyAction } from 'redux';
import { ReduxAction } from '../../enums/const-enums';
import { CardState } from '../reducers/card-reducer';

export const setAccountNumber = (accountNumber: string): AnyAction => {
  return {
    type: ReduxAction.SET_ACCOUNT_NUMBER,
    payload: { accountNumber },
  };
};

export const setCardNumber = (cardNumber: string): AnyAction => {
  return {
    type: ReduxAction.SET_CARD_NUMBER,
    payload: { cardNumber },
  };
};

export const setIsCardRemembered = (isCardRemembered: boolean): AnyAction => {
  return {
    type: ReduxAction.SET_IS_CARD_REMEMBERED,
    payload: { isCardRemembered },
  };
};

export const setIsCardSwitchAllowed = (
  isCardSwitchAllowed: boolean,
): AnyAction => {
  return {
    type: ReduxAction.SET_IS_CARD_SWITCH_ALLOWED,
    payload: { isCardSwitchAllowed },
  };
};

export const setIsCardValid = (isCardValid: boolean): AnyAction => {
  return {
    type: ReduxAction.SET_IS_CARD_VALID,
    payload: { isCardValid },
  };
};

export const setDebitCard = (card: CardState): AnyAction => {
  return {
    type: ReduxAction.SET_DEBIT_CARD,
    payload: card,
  };
};

export const setCreditCard = (card: CardState): AnyAction => {
  return {
    type: ReduxAction.SET_CREDIT_CARD,
    payload: card,
  };
};
